import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles(() => createStyles({
    root: {
        borderRadius: 24,
    },
}));
const MapButton = (props) => {
    const { className, children } = props;
    const classes = useStyles();
    return (React.createElement(Paper, { className: clsx(classes.root, className) }, children));
};
export default MapButton;
